module.exports = __webpack_public_path__ + "img/apartment.1fa15e32.svg";